// import React from "react";
// import Sidebar from "../view-audit/Sidebar";
// import "./Inspection.css";
// import CreateAudit from "./CreateAudit";
// import ViewAudit from "../view-audit/ViewAudit";
// import { useState } from "react";
// import "../App.css";
// import ViewAuditHolder from "./viewAuditHolder";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import "react-lazy-load-image-component/src/effects/blur.css";

// function Inspection() {
//   const [activeComponent, setActiveComponent] = useState("create");

//   const handleNavigation1 = () => {
//     setActiveComponent("create");
//   };

//   const handleNavigation2 = () => {
//     setActiveComponent("view");
//   };

//   const instruction1 = `${process.env.PUBLIC_URL}/bell-icon.png`;
//   const instruction2 = `${process.env.PUBLIC_URL}/MasterSidebarLogo.svg`;

//   return (
//     <div style={{ height: "100svh", display: "flex", flexDirection: "column" }}>
//       <header className="header">
//         <LazyLoadImage
//           src={instruction2}
//           alt="Left Logo"
//           className="logo left-logo"
//           effect="opacity"
//         />

//         <LazyLoadImage
//           src={instruction1}
//           alt="Right Logo"
//           className="logo right-logo"
//           effect="opacity"
//           style={{height:'25px',width:'25px'}}
//         />
//       </header>

//       <div className="app-container" style={{ display: "flex", flex: 1 }}>
//         <div
//           className="sidebar"
//           style={{
//             width: "278px",
//             boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <ul className="sidebar-menu">
//             <li
//               onClick={handleNavigation1}
//               className={activeComponent === "create" ? "active" : ""}
//             >
//               <a>
//                 <i className="sidebar-icon grey Montserrat" />Create Audit
//               </a>
//             </li>
//             <li
//               onClick={handleNavigation2}
//               className={activeComponent === "view" ? "active" : ""}
//             >
//               <a>
//                 <i className="sidebar-icon grey Montserrat" />View Audit
//               </a>
//             </li>
//           </ul>
//         </div>

//         <div
//           style={{
//             height: "86svh", // Set height to 80vh
//             overflowY: "auto", // Enable vertical scroll
//             width: "100%", // Adjust width to take into account sidebar width

//           }}
//         >
//           {activeComponent === "create" && <CreateAudit />}
//           {activeComponent === "view" && <ViewAuditHolder />}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Inspection;



import React, { useState } from "react";
import Sidebar from "../view-audit/Sidebar";
import "./Inspection.css";
import CreateAudit from "./CreateAudit";
import ViewAudit from "../view-audit/ViewAudit";
import "../App.css";
import ViewAuditHolder from "./viewAuditHolder";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Avatar from "@mui/material/Avatar";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function Inspection() {
  const [activeComponent, setActiveComponent] = useState("create");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleNavigation1 = () => {
    setActiveComponent("create");
  };

  const handleNavigation2 = () => {
    setActiveComponent("view");
  };

  const instruction1 = `${process.env.PUBLIC_URL}/bell-icon.png`;
  const instruction2 = `${process.env.PUBLIC_URL}/MasterSidebarLogo.svg`;

  // Open the popup on bell icon click
  const handleBellClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the popup
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div style={{ height: "100svh", display: "flex", flexDirection: "column" }}>
      <header className="header">
        <LazyLoadImage
          src={instruction2}
          alt="Left Logo"
          className="logo left-logo"
          effect="opacity"
          style={{marginTop:"10px"}}
        />

        <div style={{ display: "flex", alignItems: "center" }}>
          <LazyLoadImage
            src={instruction1}
            alt="Bell Icon"
            className="logo right-logo"
            effect="opacity"
            style={{ height: "25px", width: "25px", cursor: "pointer" }}
            onClick={handleBellClick}
          />

          {/* Add the R icon next to the bell icon */}
          <Avatar
            style={{
              marginLeft: "10px",
              backgroundColor: "#ff0083", // Background color similar to the one in the image
              height: "30px",
              width: "30px",
              fontSize: "16px", // Adjust font size to match the icon style
            }}
          >
            R
          </Avatar>
        </div>
       
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <div
            style={{
              position: "relative",
              padding: "16px 32px 16px 16px", // Increased right padding for the close button
              backgroundColor: "#ff0083",
              // borderRadius: "8px",
            }}
          >
            {/* Close button */}
            <IconButton
              // size="small"
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                color: "#ffffff",
                height:"8px",
                width:"8px"
              }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="body2" style={{ color: "#ffffff" }}>
              No notification
            </Typography>
          </div>
        </Popover>

      </header>

      <div className="app-container" style={{ display: "flex", flex: 1 }}>
        <div
          className="sidebar"
          style={{
            width: "278px",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <ul className="sidebar-menu">
            <li
              onClick={handleNavigation1}
              className={activeComponent === "create" ? "active" : ""}
            >
              <a>
                <i className="sidebar-icon grey Montserrat" />Create Audit
              </a>
            </li>
            <li
              onClick={handleNavigation2}
              className={activeComponent === "view" ? "active" : ""}
            >
              <a>
                <i className="sidebar-icon grey Montserrat" />View Audit
              </a>
            </li>
          </ul>
        </div>

        <div
          style={{
            height: "86svh", // Set height to 80vh
            overflowY: "auto", // Enable vertical scroll
            width: "100%", // Adjust width to take into account sidebar width
          }}
        >
          {activeComponent === "create" && <CreateAudit />}
          {activeComponent === "view" && <ViewAuditHolder />}
        </div>
      </div>
    </div>
  );
}

export default Inspection;
